import type { ReactNode } from "react";
import { Box, Flex } from "@radix-ui/themes";

type ContentProps = {
  children: ReactNode;
};

export function Content({ children }: ContentProps) {
  return <>{children}</>;
}

type FieldRowProps = {
  children: ReactNode;
};

export function FieldRow({ children }: FieldRowProps) {
  return <Flex gap="3">{children}</Flex>;
}

type FieldProps = {
  children: ReactNode;
};

export function Field({ children }: FieldProps) {
  return <Box style={{ flex: 1 }}>{children}</Box>;
}
